import {ComputedValue} from './computed-value.model';
export class TextExpression implements ComputedValue {

  expressionText: string;

}
